import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { v4 as uuidv4 } from 'uuid';

export function cn(...inputs: any[]) {
  return twMerge(clsx(inputs));
}

export function generateId() {
  return uuidv4();
}

// Generate a short random string for unique suffixes
export function generateRandomSuffix() {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 8; i += 1) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

export function generateFieldName(title: string, existingNames: string[]): string {
  // Convert title to a valid field name
  let baseName = title
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '_') // Replace non-alphanumeric with underscore
    .replace(/_+/g, '_') // Replace multiple underscores with single
    .replace(/^_|_$/g, '') // Remove leading/trailing underscores
    .slice(0, 50); // Limit length

  // If empty, use default
  if (!baseName) {
    baseName = 'field';
  }

  // Ensure uniqueness
  let finalName = baseName;

  while (existingNames.includes(finalName)) {
    finalName = `${baseName}_${generateRandomSuffix()}`;
  }

  return finalName;
}

export function toCamelCase(str: string): string {
  if (!str) return '';
  // Sanitize the string to remove characters that would result in invalid identifiers
  const sanitized = str.replace(/[^a-zA-Z0-9\s]/g, '');
  return sanitized
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
      index === 0 ? word.toLowerCase() : word.toUpperCase()
    )
    .replace(/\s+/g, '');
}
